import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=74273818&scoped=true"
import script from "./BigScreen.vue?vue&type=script&lang=ts"
export * from "./BigScreen.vue?vue&type=script&lang=ts"
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=74273818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74273818",
  null
  
)

export default component.exports